import { types, actions, Action } from '.';
import { SagaIterator } from 'redux-saga';
import { put, takeLatest, call } from 'redux-saga/effects';
import { actions as appUIActions } from '../../uis/app';
import * as experianApi from '../../../api/experianQuestion';
import { ConfirmIndentityResponse, SubmitClinicInformationResponse } from 'src/models/question';
import { actions as workflowActions } from '../../entities/workflow';
import { setAttemptCounter, increaseAttemptCounter } from 'src/utils/workflow';
import { rollbar } from 'src';

export default function* watchExperianData(): SagaIterator {
    yield takeLatest(types.SUBMIT_EXPERIAN_ANSWERS_ASYNC, submitExperianAnswersAsync);
    yield takeLatest(types.SUBMIT_EXPERIAN_QUESTIONS_ASYNC, submitExperianQuestionsAsync);
}

export function* submitExperianAnswersAsync(action: Action): SagaIterator {
    try {
        yield put(workflowActions.checkRetry(false));

        const response: ConfirmIndentityResponse = yield call(experianApi.submitConfirmIdentityAnswer, action.confirmIdentityAnswer);

        if (response != undefined) {
            yield put(workflowActions.storeWorkflowData(response.workflow));
        }

        if (response.isPass) {
            setAttemptCounter('0', false);
            yield put(actions.submitExperianAnswersSucceeded(response.isPass));
            // yield put(workflowActions.storeWorkflowData(response.workflow));
            yield put(appUIActions.setMessageIndicator('Confirm identity answers successfully, go to the step 03', 'success'));
        } else {
            increaseAttemptCounter(false);
            yield put(workflowActions.checkRetry(true));
            yield put(actions.actionServerDataFailed(response.message));
            // yield put(appUIActions.setMessageIndicator('Confirm identity answers have not been passed! Please try again.', 'error'));
            yield call(console.log, 'Confirm identity answers have not been passed!');
        }
    } catch (e) {
        yield put(actions.actionServerDataFailed(''));
        // yield put(appUIActions.setMessageIndicator('Submit confirm identity answers failed!', 'error'));
        yield call(console.log, 'Cannot submit confirm identity answers!', e);
        rollbar.error('Cannot submit confirm identity answers!');
    }
}

export function* submitExperianQuestionsAsync(action: Action): SagaIterator {
    try {
        yield put(workflowActions.checkRetry(false));

        const response: SubmitClinicInformationResponse = yield call(experianApi.submitExperianQuestions, action.confirmIdentityAnswer);

        if (response != undefined) {
            yield put(workflowActions.storeWorkflowData(response.workflow));
        }

        if (response.isPass) {
            setAttemptCounter('0', false);
            yield put(actions.submitExperianQuestionsSucceeded(response.isPass));
            yield put(appUIActions.setMessageIndicator('Confirm identity answers successfully, go to the step 03', 'success'));
        } else {
            increaseAttemptCounter(false);
            yield put(workflowActions.checkRetry(true));
            yield put(actions.submitExperianQuestionsFailed(response.message));
            yield call(console.log, 'Confirm identity answers have not been passed!');
        }
    } catch (e) {
        yield put(actions.submitExperianQuestionsFailed(''));
        yield call(console.log, 'Cannot submit confirm identity answers!', e);
        rollbar.error('Cannot submit confirm identity answers!');
    }
}


// WEBPACK FOOTER //
// ./src/modules/entities/experianQuestion/saga.ts